import React from 'react'
import { Link } from 'react-router-dom'

const FAQ: { q: string; a: string }[] = [
  {
    q: 'How does routing work?',
    a: 'A structured intake combines clinical needs, care preferences, logistics, and provider attributes into a richer routing signal. That signal is used to route each patient toward providers in your existing network who are a better fit — with a plain-language reason behind every suggestion, never an unexplained score.',
  },
  {
    q: 'Does ATUUNE replace my EHR?',
    a: 'No. ATUUNE does not replace your EHR, practice management system, scheduling tool, provider directory, or care management platform. It sits underneath those systems as a routing and continuity layer — see How It Works for the full picture.',
  },
  {
    q: 'How is Session 4 measured?',
    a: 'Session 4 is tracked as an operational milestone: whether a routed patient has attended a fourth session with their assigned provider. It is used as an early continuity indicator, not as a claim about clinical outcome or treatment success.',
  },
  {
    q: 'How does continuity monitoring work?',
    a: 'Continuity monitoring watches scheduling and rebooking activity for patterns that may indicate a patient is drifting away from care, then notifies the responsible provider or care team so they can reach out. We don’t publish the internal scoring methodology, but that operational description is complete and accurate.',
  },
  {
    q: 'Who owns the patient relationship?',
    a: 'The provider and provider organization do. ATUUNE routes patients into your existing network and monitors continuity within it — it does not intermediate the clinical relationship, and it is not a marketplace that owns or brokers the patient relationship itself.',
  },
  {
    q: 'How is PHI protected?',
    a: 'Access to patient information is role-based and scoped to what a given user is authorized to see. Multi-factor authentication is required for privileged administrative accounts. Security-relevant actions are logged. See the Security page for the complete, accurate description of what’s implemented today, including where our compliance posture still has open items.',
  },
  {
    q: 'How long does implementation take?',
    a: 'Implementation is scoped around your existing provider network rather than a rebuild of it, which is what keeps deployment fast. Exact timelines depend on network size and integration needs — talk to us for a timeline specific to your organization.',
  },
  {
    q: 'How does pricing work?',
    a: 'Pricing is outcome-aligned: no charges at signup, provider seat fees activate only after a matched patient attends their first session, and outcome fees are charged only when a matched patient reaches Session 4. See the Pricing page for tier details and an illustrative example.',
  },
  {
    q: 'What happens when a patient is flagged?',
    a: 'A continuity alert is routed to the provider or care team responsible for that patient, with enough context to support a timely outreach decision. ATUUNE surfaces the signal and the reasoning behind it — the care team decides what outreach, if any, is appropriate.',
  },
]

export default function Resources() {
  return (
    <section className="section light" style={{ minHeight: '70vh' }}>
      <h2>Resources</h2>
      <p className="lead muted">Answers to the questions we hear most from health plans and provider organizations.</p>

      <div className="section-block">
        {FAQ.map((item) => (
          <div key={item.q} className="faq-item">
            <h3>{item.q}</h3>
            <p>{item.a}</p>
          </div>
        ))}
      </div>

      <div className="actions" style={{ marginTop: 20 }}>
        <Link to="/contact">Request Demo</Link>
        <Link className="secondary outline-dark" to="/security">Read the Security Page</Link>
      </div>
    </section>
  )
}
